import React, { useEffect, useState } from 'react'
import ContentHeader from './ContentHeader'
import { useI18n } from 'contexts/AuthContext'
import { Button } from 'antd'
import notEligibleIcon from './img/ic-not-eligible.svg'
import { useUpdateClient } from 'hooks/careHooks'
import { getHealthieUserId } from 'utils/authLocalStorage'
import { logAmplitudeEvent } from 'utils/amplitudeInit'
import { mcaScreenerPromise, updateUserPromise } from 'apis/FitOnCareAPI'
import { canCloseToFitOnWeb, onCareFlowFinished } from './Rehab/util'
import { getMbiFailedInfo } from './MCA/mbiFailedCache'
import { isMobile } from 'utils/basic'

const NotEligible = (props) => {
  const { i18n } = useI18n()
  const { sku, from } = props
  const { updateClient } = useUpdateClient()

  const [isLoading, setIsLoading] = useState(false)

  const getDetail = () => {
    switch (sku) {
      case 'mca':
        return getMbiFailedInfo().unavailableDetail
      default:
        return ''
    }
  }

  const getReason = () => {
    switch (sku) {
      case 'mca':
        return getMbiFailedInfo().unavailableReason
      default:
        return ''
    }
  }

  useEffect(() => {
    if (sku === 'mca') {
      logAmplitudeEvent('Screen View: Onboarding - Not Available', {
        sku,
        Reason: getReason(),
        Detail: getDetail(),
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sku])

  const onNext = () => {
    setIsLoading(true)
    updateClient({
      variables: {
        id: getHealthieUserId(),
        active: false,
      },
      onSuccess: () => {
        if (sku === 'mca') {
          mcaScreenerPromise().then((resp) => {
            const fitonUserId = resp.data?.fitonUserId?.toString()
            onCareFlowFinished({
              sku,
              success: false,
              programId: 0,
              from,
              fitonUserId,
            })
            setIsLoading(false)
          })
        } else if (canCloseToFitOnWeb({ sku, from })) {
          // CARE-160: a rehab member with an allowed returnTo goes back to FitOn web with the fail.
          onCareFlowFinished({ sku, success: false, programId: 0, from })
          setIsLoading(false)
        } else {
          window.location.href = 'https://www.fitoncare.com'
        }
      },
    })
  }

  const onBack = (e) => {
    updateUserPromise({ activate: 0, skuStatus: { sku, status: 1 } })
    props.onBack(e)
  }

  return (
    <div className='info-sec'>
      <ContentHeader {...props} onBack={onBack} />
      <div className='info-content'>
        <img src={notEligibleIcon} alt='' className='top-icon' />
        <div className='title'>{i18n('You are not eligible')}</div>
        <div
          className='subtitle'
          style={{ marginBottom: '10px', marginTop: '17px' }}
        >
          {i18n(
            'Based on your conditions, you don’t meet the criteria for the ACCESS Program at this time. Please check back again in the future to see if you qualify.'
          )}
        </div>
        <Button
          className='btn-primary full-width-btn'
          onClick={onNext}
          loading={isLoading}
        >
          {isMobile() && sku === 'mca' ? i18n('Back to App') : i18n('Close')}
        </Button>
      </div>
    </div>
  )
}

export default NotEligible
